module.exports = __webpack_public_path__ + "static/img/logo3.04b1681.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo3.png
// module id = Tm/+
// module chunks = 1